import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import formatMoney from '../../utils/formatMoney';
import ProductPaymentDetailsComponent from './ProductPaymentDetails';
import './styles/payments.scss';

function PaymentDetail(props) {
  const { payment = {} } = props;
  const { userInfo = {}, stravaInfo } = payment;

  return (
    <Container>
      <div style={{ textAlign: 'center', fontWeight: '600' }}>Detalle de la transacción</div>
      <hr />
      <Row>
        <Col className='paymentDetails'>
          <div><strong>Usuario:</strong></div>
          <br />
          <div>{userInfo.firstName + ' ' + userInfo.lastName}</div>
          <div>{userInfo.email}</div>
          <br />
          <ProductPaymentDetailsComponent payment={payment} />
          <br />
          {
            stravaInfo &&
            <div>
              <hr />
              <div><strong>Información Carrera 2020:</strong></div>
              <div>Etapa de registro: {
                stravaInfo.registerStage === 3 ? 'Conexión con Strava exitosa' :
                  stravaInfo.registerStage === 2 ? 'Pago exitoso' : 'Elección de proyecto'

              }
              </div>
              <div>Número participante: {stravaInfo.athleteNumber}</div>
              <div>Modalidad: {stravaInfo.raceCategory}</div>
              <div>Categoría: {stravaInfo.raceAthleteCategory}</div>
              <div>Sexo: {stravaInfo.gender}</div>
              <div>Teléfono: {stravaInfo.userPhone}</div>
              <div>Monto: {formatMoney(stravaInfo.amountSelected)}</div>
              <div>Programa seleccionado: {stravaInfo.selectedProgramName}</div>
              <div>Fundación seleccionada: {stravaInfo.foundationName}</div>
              {
                stravaInfo.shirtIncluded &&
                <>
                  <div><strong>Información Camiseta:</strong></div>
                  <div>Tamaño camiseta: {stravaInfo.shirtSize}</div>
                  <div>Color camiseta: {stravaInfo.shirtColor}</div>
                  <div>Dirección de envío:
                    {`${stravaInfo.shippingAddress} ${stravaInfo.shippingAddress2} ${stravaInfo.shippingAddressCity}`}
                  </div>
                </>
              }
            </div>
          }
        </Col>
        <Col className='paymentDetails'>
          <div><strong>Pago:</strong></div>
          <br />
          <div>Estado: {payment.status}</div>
          <div>Método: {payment.paymentMethod}</div>
          <div>Tipo: {payment.type}</div>
          <div>Total: COP {formatMoney(payment.amount)}</div>
          <hr />
          <div>Comisón Pasarela: {formatMoney(payment.comisionPasarela)}</div>
          <div>Fee Pasarela: {formatMoney(payment.feePasarela)}</div>
          <div>IVA: {formatMoney(payment.iva)}</div>
          <div>Retención Fuente: {formatMoney(payment.retencionFuente)}</div>
          <div>Retención ICA: {formatMoney(payment.retencionICA)}</div>
          <div>Retención IVA: {formatMoney(payment.retencionIVA)}</div>
          <div>Tarifa Nibi: {formatMoney(payment.fareNibi)}</div>
          <div>Disponible: COP {formatMoney(payment.disponible)}</div>
        </Col>
      </Row>
    </Container>
  );
}

export default PaymentDetail;
